import { useContext } from 'react';
import FilesContext from 'contexts/FilesContext';
import { FilesContextType } from 'types/files';

// ==============================|| ESTATES - HOOKS  ||============================== //

const useFiles = () => {
    const context = useContext(FilesContext) as FilesContextType; // To ensure data and functions are not unknown when init is null;
    if (context === undefined) throw new Error("useFiles was used outside of its Provider");
    return context;
}

export default useFiles;